// // dev
// export const WEB_API = "http://localhost:4011/admin-api/";
//export const WEB_API = "http://122.155.0.74:4011/admin-api/";
// export const WEB_API = "https://apiscgsurvey.makersoft.co.th/admin-api/";
export const WEB_API = "https://scgp-riskeval-api.azurewebsites.net/admin-api/";
//export const WEB_API = "http://159.65.3.230:4011/admin-api/";
export const VERSION_RELEASE = "0.0.1.14";
